/*eslint-disable*/
export default {
  init() {
    $('.our-team__wrapper div').each(function(){
      $(this).children('div:first').show();
  });
  
  $('.our-team__wrapper ul li').click(function() {
      var $self = $(this);
      var $nav = $(this).parent();
      var $tabCtl = $nav.parent();
      $nav.find('a').removeClass("active");
      $self.find('a').addClass("active");
      $tabCtl.children('div').children('div').hide();
  
      var indexer = $self.index(); //gets the current index of (this) which is #nav li
      
      $tabCtl.children('div').children('div:eq(' + indexer + ')').fadeIn(); //uses whatever index the link has to open the corresponding box 
  });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
